module.exports = __webpack_public_path__ + "Roboto-Black.2a82f89b0a35ee7f9d45.eot";


//////////////////
// WEBPACK FOOTER
// /app/~/roboto-fontface/fonts/Roboto/Roboto-Black.eot
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-Black.eot
// module chunks = 13